<template>
  <PerfectScrollbar class="AllPwaMobile">
    <header-menu></header-menu>

    <div class="AllSiteHeaderMenu">
      <h1 class="HeaderApp">{{ $t('giftPage.inviteHeader') }}</h1>

      <div class="ShowGiftPAge">
        <img src="../assets/img/giftD.png" alt="">
      </div>

      <div class="ShowGiftImage">
        <div class="ChildShowGiftImage">
          <p>{{ $t('giftPage.userLevel') }}</p>
          <div v-if="levelUSer == '0'" class="TwoChildShowGiftImage">
            <p>( 0 )</p>
            <p> : {{ $t('giftPage.vip') }}</p>
          </div>

          <div v-if="levelUSer == '1'" class="TwoChildShowGiftImage">
            <p>( 1 )</p>
            <p> : {{ $t('giftPage.vip') }}</p>
          </div>

          <div v-if="levelUSer == '2'" class="TwoChildShowGiftImage">
            <p>( 2 )</p>
            <p> : {{ $t('giftPage.vip') }}</p>
          </div>

          <div v-if="levelUSer == '3'" class="TwoChildShowGiftImage">
            <p>( 3 )</p>
            <p> : {{ $t('giftPage.vip') }}</p>
          </div>

          <div v-if="levelUSer == '4'" class="TwoChildShowGiftImage">
            <p>( 4 )</p>
            <p> : {{ $t('giftPage.vip') }}</p>
          </div>

          <div v-if="levelUSer == '5'" class="TwoChildShowGiftImage">
            <p>( 5 )</p>
            <p> : {{ $t('giftPage.vip') }}</p>
          </div>
        </div>

        <div class="ChildShowGiftImage">
          <p>{{ $t('giftPage.yourReward') }}</p>
          <div v-if="levelUSer == '0'" class="TwoChildShowGiftImage">
            <p>{{ $t('giftPage.percent') }}</p>
            <p>10</p>
          </div>

          <div v-if="levelUSer == '1'" class="TwoChildShowGiftImage">
            <p>{{ $t('giftPage.percent') }}</p>
            <p>13</p>
          </div>

          <div v-if="levelUSer == '2'" class="TwoChildShowGiftImage">
            <p>{{ $t('giftPage.percent') }}</p>
            <p>16</p>
          </div>

          <div v-if="levelUSer == '3'" class="TwoChildShowGiftImage">
            <p>{{ $t('giftPage.percent') }}</p>
            <p>20</p>
          </div>

          <div v-if="levelUSer == '4'" class="TwoChildShowGiftImage">
            <p>{{ $t('giftPage.percent') }}</p>
            <p>20</p>
          </div>

          <div v-if="levelUSer == '5'" class="TwoChildShowGiftImage">
            <p>{{ $t('giftPage.percent') }}</p>
            <p>20</p>
          </div>
        </div>

      </div>

      <div class="InviteClassShow">
        <div class="ChildInviteClassShow">
          <VsxIcon @click="GetLink(this.userLis.username)" iconName="Code" :size="20" :color="color" type="linear" />
          <p>{{this.userLis.username}}</p>
        </div>

        <div class="ChildInviteClassShow">
          <VsxIcon @click="GetLink(fullUrl)" iconName="Code" :size="20" :color="color" type="linear" />
          <p>{{fullUrl}}</p>
        </div>
        
        <div class="copyCode">
          {{ $t('giftPage.viewDetails') }}
        </div>
      </div>

      <div class="ShowBagGiftMenu">
        <p> : {{ $t('giftPage.referredUsers') }}</p>

        <div v-for="(dataGet1 , index) in (dataGet.referred_users || [])" :key="index" class="ChildShowBagGiftMenu">
          <div class="ChildShowBagGiftMenuPng">
            <img :src="dataGet1.image || require('../assets/man/userHome.jpg')" alt="">
          </div>
          <div class="gift-user-info">
            <p class="gift-user-name">{{ dataGet1.username || 'Customer' }}</p>
            <p class="gift-user-date">{{ formatGiftDate(dataGet1.joined_at) }}</p>
          </div>
        </div>
      </div>

    </div>

    <menu-bar></menu-bar>
  </PerfectScrollbar>
</template>

<script>
import { PerfectScrollbar } from 'vue3-perfect-scrollbar'
import axios from "@/axios";
import {toast} from "vue3-toastify";

export default {
  name: 'giftUser',
  components: {
    PerfectScrollbar
  },
  data() {
    return{
      color: localStorage.getItem('theme') === 'dark' ? '#BB86FC' : '#2E1977',
      dataGet: { referred_users: [] },
      userLis: '',
      fullUrl: '',
      levelUSer: '',
    }
  },

  methods: {
    generateUrl() {
      const baseUrl = window.location.origin;
      const userData = localStorage.getItem('user');
      const level = localStorage.getItem('level');
      if (userData) {
        this.userLis = JSON.parse(userData);
        this.levelUSer = JSON.parse(level);
      }

      this.fullUrl = `${baseUrl}/register?code=${this.userLis.username}`;
    },

    GetLink(value) {
      navigator.clipboard.writeText(value);
      toast(this.$t('giftPage.codeCopied'), {
        autoClose: 3000,
        position: "top-right",
        type: "success",
      });
    },
    formatPrice(value) {
      let val = (value/1).toFixed(0).replace('.', ',')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    },

    formatGiftDate(date) {
      if (!date) return '—';
      return new Date(date).toLocaleDateString(this.$i18n?.locale === 'fa' ? 'fa-IR' : 'en-US');
    },

    async getUserCount() {
      const userData = localStorage.getItem('user');
      if (userData) {
        this.userLis = JSON.parse(userData);
      }

      let attempts = 0;
      const maxAttempts = 10;
      const delay = 100;

      while (attempts < maxAttempts) {
        try {
          const response = await axios.post('/referral-user-get', {
            id: this.userLis.id,
          });

          this.dataGet = response.data || { referred_users: [] };
          return;
        } catch (error) {
          console.error('Error fetching user planet data:', error);
        }

        attempts++;
        await new Promise(resolve => setTimeout(resolve, delay));
      }
    },

    loadTheme() {
      const savedTheme = localStorage.getItem('theme');
      if( savedTheme == "light"){
        this.color = '#2E1977'
      }else{
        this.color = '#BB86FC'
      }
    }
  },
  mounted() {
    this.getUserCount()
    this.generateUrl()
    setInterval(() => {
      this.loadTheme()
    }, 100);
  }
}
</script>

<style scoped>
.ShowBagGiftMenu {
  margin-top: 18px;
  padding: 0 14px 20px;
}

.ShowBagGiftMenu > p {
  margin: 0 0 12px;
  color: #2d2d2d;
  font-size: 15px;
  font-weight: 700;
}

.ChildShowBagGiftMenu {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  background: rgba(255, 255, 255, 0.9);
  border: 1px solid rgba(166, 134, 255, 0.28);
  border-radius: 14px;
  padding: 12px 14px;
  margin-bottom: 10px;
  box-shadow: 0 4px 12px rgba(40, 18, 99, 0.04);
  direction: rtl;
}

.gift-user-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
  min-width: 0;
  text-align: left;
  order: 2;
}

.gift-user-name {
  margin: 0;
  color: #2a1a4d;
  font-size: 15px;
  font-weight: 700;
  line-height: 1.4;
}

.gift-user-date {
  margin: 0;
  color: #7a7a7a;
  font-size: 11px;
  line-height: 1.4;
}

.ChildShowBagGiftMenuPng {
  width: 42px;
  height: 42px;
  border-radius: 50%;
  overflow: hidden;
  flex-shrink: 0;
  border: 2px solid rgba(151, 112, 255, 0.35);
  order: 1;
}

.ChildShowBagGiftMenuPng img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
</style>

